// @flow
import * as React from 'react';
import {useState, useMemo} from 'react';
import Box from 'sail/Box';
import classNames from 'classnames';

import {useStep, useFile, useFileRef} from 'docs/data/integration-builder';

import {CopyButton} from './CopyButton';

import {FileHeader} from './FileHeader';
import './RightContainer.scss';

const useHover = () => {
  const [hovered, setHovered] = useState();
  const contentEl = document.querySelector('.Content');

  const eventHandlers = useMemo(
    () => ({
      onMouseOver() {
        if (contentEl && contentEl.scrollTop > 60) {
          // Prevent the user from scrolling the Content container when they are
          // hovering over / exploring the code block and demo elements
          contentEl.style.overflowY = 'hidden';
        }
        setHovered(true);
      },
      onMouseOut() {
        if (contentEl) {
          contentEl.style.overflowY = 'auto';
        }
        setHovered(false);
      },
    }),
    [contentEl],
  );

  return {hovered, eventHandlers};
};

type RightContainerProps = {|
  demo: ?React.Element<any>,
|};

export default ({demo}: RightContainerProps) => {
  const {activeStep} = useStep();
  const {components} = useFile();

  const {hovered, eventHandlers} = useHover();
  const {fileRef} = useFileRef();

  if (!components) {
    return null;
  }

  const elements: Array<React.Element<any>> = (Object.values(components): any);

  const fadeFile = !(hovered || !activeStep || activeStep === '');

  return (
    <Box className="RightContainer">
      {demo}
      <FileHeader />
      <Box
        className={classNames('File', fadeFile && 'File--faded')}
        flex={{direction: 'column'}}
        {...eventHandlers}
      >
        <pre ref={fileRef}>{elements}</pre>
        <CopyButton />
      </Box>
    </Box>
  );
};
